export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/users/organisation-owner/:id/organisations', 'admin.organisation-owner-user-organisations')
    .when('/admin/users/organisation-owner/:id/info', 'admin.organisation-owner-user-info')
    .when('/admin/users/organisation-owner/:id/settings', 'admin.organisation-owner-user-settings')

    .within('admin')

    .segment('organisation-owner-user-organisations', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.organisation_owner_info',
        }
      ],
      template: '<admin-organisation-owner-organisations-page></admin-organisation-owner-organisations-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-owner-organisations.module" */ "./organisation-owner-organisations/admin-organisation-owner-organisations.module");
      }
    })

    .segment('organisation-owner-user-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.organisation_owner_info',
        }
      ],
      template: '<admin-organisation-owner-personal-info-page></admin-organisation-owner-personal-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-owner-personal-info.module" */ "./organisation-owner-personal-info/admin-organisation-owner-personal-info.module");
      }
    })

    .segment('organisation-owner-user-settings', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.organisation_owner_info',
        }
      ],
      template: '<admin-organisation-owner-settings-page></admin-organisation-owner-settings-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-owner-settings.module" */ "./organisation-owner-settings/admin-organisation-owner-settings.module");
      }
    })
}
